import logo from './logo.svg';
import './App.css';
// import Homepage from './Homepage/Homepage';
import Homepage from './Homepage/Homepage'

function App() {
  return (
    <Homepage/>
  );
}

export default App;
